import { render } from "./UserOrders.vue?vue&type=template&id=3070ddf1&scoped=true"
import script from "./UserOrders.vue?vue&type=script&lang=js"
export * from "./UserOrders.vue?vue&type=script&lang=js"

import "./UserOrders.vue?vue&type=style&index=0&id=3070ddf1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3070ddf1"]])

export default __exports__